import React, { useState } from "react";
import { Urls } from "../../Urls";
import classes from "./FreightRates.module.css";
import "./style.css";
import { Container, Row, Column } from "../Shared/FlexDiv/FlexDiv";
import Select from "react-select";
import { validateInputs } from "../DiscoverNow/Utitlity";
import BenchmarkMasterView from "./BenchmarkMasterView";
import { SelectLane } from "./Utility";
import Loader from "../Loader";
import Uploads from "./BenchmarkMasterView/Uploads";
import { Link, useHistory } from "react-router-dom";
import ShowUploadedLanes from "./ShowUploadedLanes/ShowUploadedLanes";
import ModuleHeading from "../Shared/ModuleHeading/ModuleHeading";
import ControlledPopupModal from "../Shared/PopupModal/ControlledPopupModal/ControlledPopupModal";
import BenchmarkHistory from "../Billing&Payment/BenchmarkHistory";
import CalendlyPopupButton from "../Shared/CalendlyPopupButton/CalendlyPopupButton";
import { CALENDLY_URL } from "../../config/calendly";
import { AlertPopup } from "../Shared/AlertPopup/AlertPopup";
import { HiArrowRight } from "react-icons/hi2";


const FreightRatesDesktop = ({
  show,
  userDetails,
  activeStep,
  setActiveStep,
  allowedLanes,
  allowedSessions,
  maxlanes,
  currentLaneList,
  userInput,
  handleChange,
  getDataForLane,
  addSelectedLane,
  getSessionID,
  attachments,
  setAttachments,
  upload_allowed,
  setupload_allowed,
  updateCurrentLaneList,
  getExcelDetails,
  lspload,
  excel_details,
  history,
  previousEnquiry,
  allowedrate,
  setallowedrate,
  allowedtransporter,
  setallowedtransporter,
  togglerates,
  setTogglerates,
  LSPCollapsed,
  setLSPCollapsed,
  lspLanes,
  setLspLanes,
  qualitativeInputs,
  setQualitativeInputs,
  resetData,
  toggleNav,
  collapsed,
  sessionid,
  setSessionid,
  selectedLane,
  setSelectedLane,
  handleChangeForLanes,
  userContent,
  setShow,
  alertPopupOpen,
  setAlertPopupOpen,
  alertPopupMessage,
  showNoCreditsModal,
  setShowNoCreditsModal,
}) => {
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [showCalendly, setShowCalendly] = useState(false);
  const [showBookingConfirmation, setShowBookingConfirmation] = useState(false);
  const routerHistory = useHistory();
  return (
    <Container className={classes["mycontainer"]}>
      <Loader show={show} />
      {userDetails &&
      userDetails?.policy &&
      userDetails?.policy?.benchmarknow &&
      userDetails?.policy?.benchmarknow?.allowed &&
      userDetails?.policy?.benchmarknow?.allowed === "yes" ? (
        <>
          <ModuleHeading
            title={"LoRRI Benchmark (for contracted freight)"}
            fontSize="20px"
          />

          <Row
            className={`${classes["flex100"]} ${classes["remaining-lanes"]}`}
          >
            {activeStep === 0 ? (
              <Column
                id="mySidepanel"
                className={` ${classes["flex-left"]} sidepanel`}
              >
                <Column className={classes["padding-1"]}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                      margin: "0",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        gap: "6px",
                      }}
                    >
                      <span
                        style={{
                          color: "white",
                          fontSize: "13px",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                          Lane Credits: {allowedLanes - currentLaneList.length}
                      </span>
                      {history && history.length > 0 && (
                        <button
                          id="btnHistoryTop"
                          style={{
                            padding: "6px 14px",
                            fontSize: "12px",
                            color: "white",
                            fontWeight: "600",
                            background: "linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.08) 100%)",
                            borderRadius: "20px",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            border: "1px solid rgba(255, 255, 255, 0.3)",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            cursor: "pointer",
                            outline: "none",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "linear-gradient(135deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.15) 100%)";
                            e.currentTarget.style.boxShadow = "0 6px 20px rgba(255, 255, 255, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.3)";
                            e.currentTarget.style.transform = "translateY(-1.5px)";
                            const icon = e.currentTarget.querySelector(".fa-history");
                            if (icon) icon.style.transform = "rotate(-360deg)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.08) 100%)";
                            e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.2)";
                            e.currentTarget.style.transform = "none";
                            const icon = e.currentTarget.querySelector(".fa-history");
                            if (icon) icon.style.transform = "none";
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            previousEnquiry(e);
                            setShowHistoryModal(true);
                          }}
                        >
                          <i
                            className="fa fa-history"
                            style={{
                              fontSize: "12px",
                              transition: "transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
                            }}
                          />
                          History
                        </button>
                      )}
                    </div>
                  </div>
                  <hr className={`${classes["divider"]}`} />
                  <div>
                    <div data-tut="reactour__inputs">
                      <SelectLane
                        userInput={userInput}
                        id="origin"
                        handleChange={handleChange}
                        label="Origin"
                        valueKey="origin"
                        inputKey="inputOrigin"
                        className={`${classes["AutosuggestInputClass"]}`}
                      />

                      <SelectLane
                        userInput={userInput}
                        id="destination"
                        handleChange={handleChange}
                        label="Destination"
                        valueKey="destination"
                        inputKey="inputDestination"
                        className={`${classes["AutosuggestInputClass"]}`}
                      />
                      {userInput.origin &&
                      userInput.destination &&
                      userInput.inputOrigin &&
                      userInput.inputDestination &&
                      userInput.inputOrigin === userInput.inputDestination ? (
                        <span className={`${classes["s-error"]}`}>
                          Source and Destination cannot be same
                        </span>
                      ) : null}
                      <label
                        style={{ fontWeight: "100", fontSize: "15px" }}
                        className="mt-3"
                      >
                        Select Truck Type
                      </label>
                      <Select
                        id="truck_type_selector"
                        options={userInput.options}
                        value={userInput.selectedTruckType}
                        onChange={(value) =>
                          handleChange("selectedTruckType", value)
                        }
                        openMenuOnClick={true}
                        onMenuOpen={(e) =>
                          getDataForLane(
                            userInput.origin,
                            userInput.destination,
                            userInput.inputOrigin,
                            userInput.inputDestination
                          )
                        }
                        isDisabled={
                          !validateInputs(
                            userInput.origin,
                            userInput.inputOrigin,
                            userInput.destination,
                            userInput.inputDestination,
                            "",
                            false
                          )
                        }
                        isLoading={userInput.isOptionsLoading}
                        className={"Truck_Type_Select mb-3"}
                        classNamePrefix={"Truck_Prefix"}
                      />
                    </div>

                    {
                      <>
                        <div data-tut="reactour__add">
                          <Column
                            className={`${classes["align-left-width-small"]}`}
                          >
                            <button
                              disabled={
                                validateInputs(
                                  userInput.origin,
                                  userInput.inputOrigin,
                                  userInput.destination,
                                  userInput.inputDestination,
                                  "",
                                  false
                                ) && userInput.selectedTruckType
                                  ? false
                                  : true
                              }
                              onClick={(e) => addSelectedLane()}
                              className="btn btn-sm btn-success"
                            >
                              <i className="fa fa-plus" /> Add
                            </button>
                          </Column>
                        </div>
                        <div data-tut="reactour__getbenchmark">
                          <Column style={{ marginTop: "8%" }}>
                            <center>
                              <button
                                className="btn btn-success"
                                disabled={
                                  currentLaneList && currentLaneList.length > 0
                                    ? false
                                    : true
                                }
                                onClick={getSessionID}
                              >
                                Get LoRRI Benchmark
                              </button>
                            </center>
                          </Column>
                        </div>
                        <Column style={{ color: "white", marginTop: "6%" }}>
                          <label style={{ textAlign: "center" }}>
                            - - - - - - - - - - OR - - - - - - - - - -
                          </label>
                          <Row style={{ justifyContent: "center" }}>
                            <Uploads
                              updateCurrentLaneList={updateCurrentLaneList}
                              allowedLanes={allowedLanes}
                              buttonID="ExcelFileUploaderForBenchmarkNow"
                              toggleLoader={setShow}
                              attachments={attachments}
                              setAttachments={setAttachments}
                              userDataObject={userDetails}
                              upload_allowed={upload_allowed}
                              setupload_allowed={setupload_allowed}
                              onClose={(e) => {
                                setTimeout(() => {
                                  getExcelDetails();
                                }, [localStorage.getItem("excelcount") * 1000]);
                              }}
                            />
                          </Row>
                        </Column>
                      </>
                    }
                  </div>

                  {!lspload ? (
                    <div style={{ marginTop: "4%" }}>
                      {!excel_details.benchmark_seen &&
                      excel_details.page === "completed" &&
                      allowedLanes > 0 ? (
                        <a
                          href="#"
                          onClick={(e) => setActiveStep(2)}
                          style={{
                            padding: "0%",
                            fontSize: "17px",
                            color: "white",
                            fontWeight: "600",
                            marginLeft: "20%",
                            cursor: "pointer",
                          }}
                        >
                          <u>View Uploaded Lanes</u>
                        </a>
                      ) : (
                        <div
                          style={{
                            padding: "0%",
                            fontSize: "17px",
                            color: "#727271",
                            fontWeight: "600",
                            marginLeft: "20%",
                            textDecoration: "underline",
                          }}
                        >
                          View Uploaded Lanes
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className={`${classes["my-row"]}`}>
                      <div className={`${classes["my-loader"]}`} />
                      <span style={{ textAlign: "left", marginLeft: "7%" }}>
                        Fetching Rates, Please Wait...
                      </span>
                    </div>
                  )}

                    {/* <div style={{ marginTop: "10%", textAlign: "center" }}>
                    {history && history.length > 0 ? (
                      <button
                        id="gototrucks"
                        style={{
                          padding: "0%",
                          fontSize: "13px",
                          color: "white",
                          fontWeight: "600",
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        className={`btn btn-sm btn-link`}
                        onClick={(e) => {
                          e.preventDefault();
                          previousEnquiry(e);
                          setShowHistoryModal(true);
                        }}
                      >
                        Click here to view your previous enquiries
                      </button>
                    ) : null}
                  </div> */}
                </Column>
              </Column>
            ) : null}
            <Column className={`${classes["position-relative"]}`}>
                {allowedLanes === 0 && (
                  <div
                    style={{
                      width: "100%",
                      background: "#FFF9E6",
                      borderTop: "1px solid #FFE0B2",
                      borderBottom: "1px solid #FFE0B2",
                      padding: "10px 24px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      boxSizing: "border-box",
                      marginBottom: "15px",
                      fontFamily: "inherit",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#5D4037",
                        fontWeight: "500",
                      }}
                    >
                      You have reached the lane benchmarking limit for your current plan. Please upgrade to continue.                  </span>
                    <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                      <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                        <button
                          onClick={() => setShowNoCreditsModal(true)}
                          style={{
                            padding: "6px 16px",
                            fontSize: "13px",
                            color: "white",
                            fontWeight: "600",
                            backgroundColor: "#2E7D32",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                          }}
                        >
                          Upgrade now
                        </button>
                      </div>
                      {history && history.length > 0 && (
                        <button
                          style={{
                            padding: "5px 15px",
                            fontSize: "13px",
                            color: "#E67E22",
                            fontWeight: "600",
                            backgroundColor: "transparent",
                            border: "1px solid #E67E22",
                            borderRadius: "6px",
                            cursor: "pointer",
                            transition: "all 0.2s",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            previousEnquiry(e);
                            setShowHistoryModal(true);
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "rgba(230, 126, 34, 0.08)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "transparent";
                          }}
                        >
                          View history
                        </button>
                      )}
                    </div>
                  </div>
                )}
              {activeStep === 2 ? (
                <ShowUploadedLanes
                  allowedLanes={allowedLanes}
                  excel_id={excel_details.excel_id}
                />
              ) : (
                <BenchmarkMasterView
                  allowedLanes={allowedLanes}
                  allowedSessions={allowedSessions}
                  currentLaneList={currentLaneList}
                  allowedrate={allowedrate}
                  setallowedrate={setallowedrate}
                  allowedtransporter={allowedtransporter}
                  setallowedtransporter={setallowedtransporter}
                  togglerates={togglerates}
                  setTogglerates={setTogglerates}
                  updateCurrentLaneList={updateCurrentLaneList}
                  toggleLoader={setShow}
                  LSPCollapsed={LSPCollapsed}
                  getSessionID={getSessionID}
                  setLSPCollapsed={setLSPCollapsed}
                  maxlanes={maxlanes}
                  history={history}
                  lspLanes={lspLanes}
                  setLspLanes={setLspLanes}
                  qualitativeInputs={qualitativeInputs}
                  setqualitativeInputs={setQualitativeInputs}
                  activeStep={activeStep}
                  setActiveStep={setActiveStep}
                  userDataObject={userDetails}
                  resetData={resetData}
                  toggleNav={toggleNav}
                  collapsed={collapsed}
                  sessionid={sessionid}
                  setSessionid={setSessionid}
                  selectedLane={selectedLane}
                  setSelectedLane={setSelectedLane}
                  handleChange={handleChangeForLanes}
                  onCalendlyScheduled={() => setShowBookingConfirmation(true)}
                />
              )}
            </Column>
          </Row>
        </>
      ) : (
        userContent
      )}
      <ControlledPopupModal
        isOpen={showHistoryModal}
        onClose={() => setShowHistoryModal(false)}
        title="Benchmark History"
        size="lg"
        content={<BenchmarkHistory />}
      />
      <ControlledPopupModal
        isOpen={showNoCreditsModal}
        onClose={() => setShowNoCreditsModal(false)}
        hideHeader={true}
        centered={true}
        backdrop={true}
        backdropClassName={classes["credits-exhausted-modal-backdrop"]}
        size="sm"
        dialogClassName={classes["credits-exhausted-modal"]}
        content={
          <div style={{ textAlign: "center", padding: "16px 12px 8px 12px", fontFamily: "Inter, sans-serif" }}>
            <div style={{ fontSize: "48px", marginBottom: "16px" }}>🎁</div>
            <h3 style={{ fontSize: "20px", fontWeight: "700", color: "#0f172a", marginBottom: "12px", letterSpacing: "-0.01em" }}>
              You're out of free credits
            </h3>
            <p style={{ fontSize: "14px", color: "#475569", lineHeight: "1.5", marginBottom: "24px" }}>
              Your 2 free credits cover 2 lanes. Book a quick demo to benchmark your lanes and see your full savings potential.
            </p>
            <button
              onClick={() => {
                setShowNoCreditsModal(false);
                setShowCalendly(true);
              }}
              style={{
                backgroundColor: "#23a455",
                color: "#ffffff",
                border: "none",
                borderRadius: "14px",
                padding: "14px 24px",
                fontSize: "15px",
                fontWeight: "600",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(35, 164, 85, 0.2)",
                transition: "all 0.2s ease"
              }}
            >
              Express interest <HiArrowRight style={{ fontSize: "16px" }} />
            </button>
            <button
              onClick={() => setShowNoCreditsModal(false)}
              style={{
                display: "block",
                margin: "16px auto 0 auto",
                fontSize: "14px",
                color: "#64748b",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontWeight: "500",
                outline: "none",
                transition: "color 0.2s ease"
              }}
            >
              Maybe later
            </button>
          </div>
        }
      />
      <CalendlyPopupButton
        url={CALENDLY_URL}
        text=""
        open={showCalendly}
        moduleName="benchmark_lane_limit_desktop"
        style={{ display: "none" }}
        onCalendlyDropOff={() => setShowCalendly(false)}
        onCalendlyScheduled={() => {
          setShowCalendly(false);
          setShowBookingConfirmation(true);
        }}
      />
      <ControlledPopupModal
        isOpen={showBookingConfirmation}
        onClose={() => setShowBookingConfirmation(false)}
        hideHeader={true}
        centered={true}
        backdrop={true}
        backdropClassName={classes["credits-exhausted-modal-backdrop"]}
        size="sm"
        dialogClassName={classes["credits-exhausted-modal"]}
        content={
          <div style={{ textAlign: "center", padding: "16px 12px 8px 12px", fontFamily: "Inter, sans-serif" }}>
            <div style={{ display: "inline-flex", justifyContent: "center", marginBottom: "16px" }}>
              <div style={{ width: "48px", height: "48px", border: "2.5px solid #0f172a", borderRadius: "10px", overflow: "hidden", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "#ffffff" }}>
                <div style={{ background: "#ef4444", width: "100%", color: "#ffffff", fontSize: "9px", fontWeight: "700", textTransform: "uppercase", padding: "2px 0", textAlign: "center", borderBottom: "2.5px solid #0f172a" }}>July</div>
                <div style={{ fontSize: "20px", fontWeight: "800", color: "#0f172a", lineHeight: "1.2" }}>17</div>
              </div>
            </div>
            <h3 style={{ fontSize: "20px", fontWeight: "800", color: "#0f172a", marginBottom: "10px", letterSpacing: "-0.01em" }}>
              Your demo is scheduled
            </h3>
            <p style={{ fontSize: "13px", color: "#64748b", lineHeight: "1.5", marginBottom: "24px" }}>
              You're booked. We've sent the invite to your work email and we'll send a reminder before the call.
            </p>
            <button
              onClick={() => {
                setShowBookingConfirmation(false);
                setShowCalendly(true);
              }}
              style={{
                backgroundColor: "#0f172a",
                color: "#ffffff",
                border: "none",
                borderRadius: "14px",
                padding: "14px 24px",
                fontSize: "15px",
                fontWeight: "600",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                transition: "all 0.2s ease"
              }}
            >
              Reschedule
            </button>
            <button
              onClick={() => setShowBookingConfirmation(false)}
              style={{
                display: "block",
                margin: "16px auto 0 auto",
                fontSize: "14px",
                color: "#64748b",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontWeight: "500",
                outline: "none"
              }}
            >
              Back to benchmark
            </button>
          </div>
        }
      />
      <AlertPopup
        show={alertPopupOpen}
        onClose={() => setAlertPopupOpen(false)}
        withHeader={true}
        headerTitle="LoRRI Benchmark"
      >
        <div style={{ padding: "10px 0 16px 0", fontSize: "15px", color: "#333" }}>
          {alertPopupMessage}
        </div>
      </AlertPopup>
    </Container>
  );
};

export default FreightRatesDesktop;
